import { render, staticRenderFns } from "./ReportManageModal.vue?vue&type=template&id=27cc9ff0&"
import script from "./ReportManageModal.vue?vue&type=script&lang=js&"
export * from "./ReportManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports